// Notities (0060_notes). Handgeschreven zoals ui.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/notes.ts); openapi.contract.test.ts bewaakt elke aanroep.
const id = (v) => encodeURIComponent(v);
export function createNotesClient(t) {
    return {
        list: () => t.request('GET', '/v1/app/notes'),
        create: (input) => t.request('POST', '/v1/app/notes', input),
        update: (noteId, input) => t.request('PATCH', `/v1/app/notes/${id(noteId)}`, input),
        remove: (noteId) => t.request('DELETE', `/v1/app/notes/${id(noteId)}`),
        voiceUrl: (noteId) => `${t.baseUrl}/v1/app/notes/${id(noteId)}/voice`,
    };
}
//# sourceMappingURL=notes.js.map